import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, FieldArray } from 'redux-form'
import { FormButtons, renderers, validations } from '../../../components'

const validateConsignmentOrder = (values) => {
  const errors = {}
  if (!values.parts || !values.parts.length) {
    errors.parts = { _error: 'At least one part must be added' }
  } else {
    const partsArrayErrors = []
    values.parts.forEach((member, memberIndex) => {
      const memberErrors = {}
      if (!member || !member.number) {
        memberErrors.number = 'Required'
        partsArrayErrors[memberIndex] = memberErrors
      }

      if (
        member &&
        member.is_serialized &&
        !(member.device && member.device.id)
      ) {
        memberErrors.device = { id: 'Required' }
        partsArrayErrors[memberIndex] = memberErrors
      }
      if (
        member &&
        member.is_serialized &&
        !(parseInt(member.quantity) === 1)
      ) {
        memberErrors.quantity = 'Set Quantity to 1 for Serialized Items'
        partsArrayErrors[memberIndex] = memberErrors
      }

      if (partsArrayErrors.length) {
        errors.parts = partsArrayErrors
      }
    })
  }
  return errors
}

const renderParts = ({ fields, meta: { error, submitFailed } }) => (
  <>
    {fields.map((member, index) => (
      <div key={index}>
        <button
          type="button"
          title="Remove Member"
          onClick={() => fields.remove(index)}
        />
        <h6>Part #{index + 1}</h6>

        <Field
          name={`${member}.number`}
          type="text"
          component={renderers.renderField}
          label="Part Number"
        />
        <Field
          label="Is Serialized Item"
          name={`${member}.is_serialized`}
          component={renderers.renderRadioField}
        />
        {!member.is_serialized ? (
          <Field
            name={`${member}.quantity`}
            type="text"
            component={renderers.renderField}
            label="Quantity"
          />
        ) : (
          ''
        )}

        <Field
          label="Device ID"
          name={`${member}.device.id`}
          validate={
            fields[index] && fields[index].is_serialized
              ? [validations.required]
              : []
          }
          component={renderers.renderField}
          type="text"
        />
      </div>
    ))}
    <div>
      <ReactBootstrap.Button variant="dark" onClick={() => fields.push({})}>
        Add Return Part
      </ReactBootstrap.Button>
      {submitFailed && error && <span>{error}</span>}
    </div>
  </>
)

const ConsignmentDecreaseOrderFormHTML = (props) => {
  const { handleSubmit } = props

  return (
    <form onSubmit={handleSubmit}>
      <Field
        label="Order ID"
        name="orderId"
        validate={[validations.required]}
        component={renderers.renderField}
        type="text"
      />
      <Field
        label="Ship To"
        name="shipTo"
        validate={[validations.required]}
        component={renderers.renderField}
        type="text"
      />

      <FieldArray name="parts" component={renderParts} />

      <FormButtons />
    </form>
  )
}

export const ConsignmentDecreaseOrderForm = reduxForm({
  form: 'consignment-order-form',
  validate: validateConsignmentOrder,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ConsignmentDecreaseOrderFormHTML)
